import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    jumpTo: null,
    ajax_spinner: false,
    visible_dialog: null,
    dropdown: false,
};
export const slice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        appAjaxSpinner(state, action) {
            state.ajax_spinner = action.payload;
        },
        showDialog(state, action) {
            state.visible_dialog = action.payload;
        },
        hideDialog(state) {
            state.visible_dialog = null;
        },
        jumpTo(state, action) {
            state.jumpTo = action.payload;
        },
    }
});
export const { appAjaxSpinner, showDialog, hideDialog, jumpTo, } = slice.actions;
export const app = slice.reducer;
